import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo } from "react";
import { SharePublicBoardModal } from "~/components/Modals/SharePublicBoardModal";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { PublicBoardDownloadMenu } from "~/components/Shared/HeaderBar/PublicBoardDownloadMenu";
import { SHARE_BUTTON } from "~/constants/testIDs";
import { useAppliedFiltersCount } from "~/hooks/filters/useAppliedFiltersCount";
import { useSearchParams } from "~/hooks/search/useSearchParams";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { getPublicSubboardShareUrl } from "~/swr-hooks/shortUrl/utils";
import { canGenerateZip } from "~/utils/permissions/taskPermissions";
export const PublicBoardHeaderActions = /*#__PURE__*/ memo((param)=>{
    let { board } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const [showSharePublicBoardModal] = useAirModal(SharePublicBoardModal);
    const { permissions } = usePublicPermissions();
    const { shortId } = useShortIdContext();
    const { search } = useSearchParams();
    const { filtersCount } = useAppliedFiltersCount();
    const { ui2 } = useTemporaryFeatureFlags();
    const canDownload = canGenerateZip(permissions);
    if (!isAboveMediumScreen || !!filtersCount || !!search) {
        return null;
    }
    const onShareClick = ()=>showSharePublicBoardModal({
            id: board.id,
            url: getPublicSubboardShareUrl(shortId, board.id),
            trackLocation: "header"
        });
    if (ui2) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex shrink-0",
            children: [
                canDownload && /*#__PURE__*/ _jsx(Button, {
                    size: "large",
                    appearance: "filled",
                    color: "grey",
                    "data-testid": SHARE_BUTTON,
                    onClick: onShareClick,
                    children: "Copy Link"
                }),
                canDownload && /*#__PURE__*/ _jsx(PublicBoardDownloadMenu, {
                    board: board
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex shrink-0",
        children: [
            canDownload ? /*#__PURE__*/ _jsx(IconButton, {
                label: "Share",
                icon: Link,
                size: "large",
                appearance: "filled",
                color: "grey",
                "data-testid": SHARE_BUTTON,
                onClick: onShareClick
            }) : /*#__PURE__*/ _jsx(Button, {
                size: "large",
                appearance: "filled",
                color: "grey",
                "data-testid": SHARE_BUTTON,
                onClick: onShareClick,
                children: "Share"
            }),
            canDownload && /*#__PURE__*/ _jsx(PublicBoardDownloadMenu, {
                board: board
            })
        ]
    });
});
PublicBoardHeaderActions.displayName = "PublicBoardHeaderActions";
